import { CheckEmail } from "@entities/Onboarding/ui/CheckEmail";
import { ForgotPasswordForm } from "@entities/Onboarding/ui/ForgotPasswordForm";
import { LoginForm } from "@entities/Onboarding/ui/LoginForm";
import { TwoFactorForm } from "@entities/Onboarding/ui/TwoFactorForm";
import { AuthStep } from "@pages/Onboarding/Onboarding";
import cn from "classnames";
import { useEffect, useState } from "react";
import styles from "./styles.module.scss";
import { useAuth } from "@entities/auth";
import { useGetMe } from "@entities/Onboarding/lib/hooks/useGetMe";

export default function Authflow() {
  const [step, setStep] = useState<AuthStep>("LOGIN");
  const [isTransitioning, setIsTransitioning] = useState(false);
  const { user } = useAuth();
  const { userDetails } = useGetMe();

  // if any api before logging in fails with 401 status

  useEffect(() => {
    if (!user && !userDetails) {
      navigateTo("LOGIN");
    }
  }, [user, userDetails]);

  const navigateTo = (nextStep: AuthStep) => {
    setIsTransitioning(true);
    setTimeout(() => {
      setStep(nextStep);
      setIsTransitioning(false);
    }, 200);
  };

  const renderStep = () => {
    switch (step) {
      case "LOGIN":
        return <LoginForm navigateTo={navigateTo} />;
      case "FORGOT_PASSWORD":
        return <ForgotPasswordForm navigateTo={navigateTo} />;
      case "CHECK_EMAIL":
        return <CheckEmail navigateTo={navigateTo} />;
      case "TWO_FACTOR":
        return <TwoFactorForm navigateTo={navigateTo} />;
      default:
        return null;
    }
  };
  return (
    <div className={styles.card}>
      <div
        className={cn(styles.cardContent, {
          [styles.cardContentTransitioning]: isTransitioning,
        })}
      >
        {renderStep()}
      </div>

      {step !== "CHECK_EMAIL" && (
        <div className={styles.footer}>
          <p className={styles.footerText}>
            {step === "LOGIN" ? "New to cloutflow?" : "Need help?"}{" "}
            <a className={styles.contactLink}>Contact us</a>
          </p>
        </div>
      )}
    </div>
  );
}
